
    import { mapState } from 'vuex';
    import ApplyFormCustomNotice from '@/components/JobView/Apply/ApplyFormCustomNotice';

    export default {
        name: 'ApplyHeader',
        components: { ApplyFormCustomNotice },
        data() {
            return {};
        },

        computed: {
            ...mapState({
                $_jobApplication: state => state.jobApplication,
                $_job: state => state.job.job,
            }),
        },
    };
